// 音声サーバ（VS）HTTP API の薄いクライアント（AI-WF265 / 要望#213）。
// konecco の axios（baseURL が BE 向き）は使えないので素の fetch。ただし VS を公開した以降は
// 認証が要るため、同じ JWT を Authorization ヘッダで付ける（VS 側 VOICE_AUTH_REQUIRED=1）。

import { voiceAuthHeaders, voiceHttpUrl } from './voice-config';
import type { CallAllocation, CallSummary } from './voice-types';

async function toJson<T>(res: Response, what: string): Promise<T> {
  if (!res.ok) {
    let reason = '';
    try {
      reason = (await res.json())?.message ?? '';
    } catch {
      /* body なしは無視 */
    }
    throw new Error(`${what} failed: HTTP ${res.status}${reason ? ` (${reason})` : ''}`);
  }
  return (await res.json()) as T;
}

/** 会話開始（割り当て）。既存会話に紐付ける場合は conversationId を渡す */
export async function createCall(conversationId?: string): Promise<CallAllocation> {
  const res = await fetch(voiceHttpUrl('/v1/calls'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...voiceAuthHeaders() },
    body: JSON.stringify(conversationId ? { conversationId } : {}),
  });
  return toJson<CallAllocation>(res, 'createCall');
}

/** セッション summary（上り字幕 transcript / lastPartial の取得口）。404=セッション消滅 */
export async function getCallSummary(callId: string): Promise<CallSummary | null> {
  const res = await fetch(voiceHttpUrl(`/v1/calls/${encodeURIComponent(callId)}`), {
    headers: voiceAuthHeaders(),
  });
  if (res.status === 404) return null;
  return toJson<CallSummary>(res, 'getCallSummary');
}

/** テキスト注入シーム（#213 用に #210 が用意）。既存会話では meta 不要（BE が ConversationChannel から解決） */
export async function postCallText(
  callId: string,
  text: string,
): Promise<{ utteranceId: string; conversationId: string }> {
  const res = await fetch(voiceHttpUrl(`/v1/calls/${encodeURIComponent(callId)}/text`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...voiceAuthHeaders() },
    body: JSON.stringify({ text }),
  });
  return toJson(res, 'postCallText');
}
